"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.taskFinished = void 0;
const plugin_html_multi_response_1 = __importDefault(require("@jspsych-contrib/plugin-html-multi-response"));
const helpers_1 = require("../helpers");
const __1 = require("../../..");
const taskStore_1 = require("../../../taskStore");
const utils_1 = require("../../../utils");
function endTask() {
    (0, taskStore_1.taskStore)('taskComplete', true);
    window.removeEventListener('click', endTask);
    window.removeEventListener('keydown', endTask);
}
const taskFinished = (endMessage = 'taskFinished') => {
    return {
        type: plugin_html_multi_response_1.default,
        data: () => {
            return {
                // save_trial: true,
                assessment_stage: 'instructions',
            };
        },
        stimulus: () => {
            const t = (0, taskStore_1.taskStore)().translations;
            return `
          <div class='lev-stimulus-container'>
            <div class='lev-row-container instruction'>
              <h1>${t[endMessage]}</h1>
            </div>
              <footer>${t.generalFooter}</footer>
          </div>`;
        },
        button_choices: [`Continue`],
        keyboard_choices: 'ALL_KEYS',
        button_html: '<button class="primary" style=margin-top:10%>Exit</button>',
        on_load: () => {
            window.addEventListener('click', endTask);
            window.addEventListener('keydown', endTask);
            if (__1.mediaAssets.audio[endMessage]) {
                helpers_1.PageAudioHandler.playAudio(__1.mediaAssets.audio[endMessage]);
            }
            const logger = utils_1.Logger.getInstance();
            logger.capture('Task Finished', {
                taskName: (0, taskStore_1.taskStore)().task,
                taskFinished: (0, taskStore_1.taskStore)().taskComplete,
            });
        },
        // trial_duration: 1000,
    };
};
exports.taskFinished = taskFinished;
